import React from 'react'
import {Box, Text, Button, useMultiStyleConfig, Link, Flex} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const SubscriptionAssistance = () => {
    const styles = useMultiStyleConfig('Subscriptions')
    const {buildUrl} = useMultiSite()

    return (
        <Box {...styles.assistanceContainer} {...styles.subscriptionGap}>
            <Flex flexDir="column" width="100%" gap="xsmall.base">
                <Text {...styles.assistanceTitle}>
                    <FormattedMessage
                        defaultMessage="Subscription assistance"
                        id="account_subscription_history.subscription_assistance.title"
                    />
                </Text>
                <Text {...styles.assistanceDescription}>
                    <FormattedMessage
                        defaultMessage="At the moment, subscription management is not available directly on the site. For any request or modification, our Customer Care team is at your disposal."
                        id="account_subscription_history.subscription_assistance.description"
                    />
                </Text>
            </Flex>
            <Button
                as={Link}
                href={buildUrl('/contact-us')}
                variant="primary"
                {...styles?.assistanceButton}
            >
                <FormattedMessage
                    id="account_subscription_history.subscription_assistance.button"
                    defaultMessage="Contact us"
                />
            </Button>
        </Box>
    )
}

export default SubscriptionAssistance
